import axios from 'api/config'

export default function updateCalculatorProject(id, params) {
  return axios
    .put(`calculator`, { calculator_project: params, id })
    .then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/helpers/updateCalculatorProject.js